
export type GetNotifications200NotificationsItemBasicInfoType = typeof GetNotifications200NotificationsItemBasicInfoType[keyof typeof GetNotifications200NotificationsItemBasicInfoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNotifications200NotificationsItemBasicInfoType = {
  LIKE: 'LIKE',
  REPLY: 'REPLY',
  RETWEET: 'RETWEET',
  FOLLOW: 'FOLLOW',
  MENTION: 'MENTION',
} as const;
